import React from "react";

export const HowCreateNewArtistCard: React.FC = () => {
  return <div id={"HowCreateNewArtistCard"}>
    <h2>
      Как создать новую карточку артиста
    </h2>
    <p>
      В случае, если у артиста ещё нет карточки на площадке, её можно создать перед публикацией первого релиза. Для
      этого кликните на кнопку "+ Создать артиста" и введите корректное название будущей карточки в появившемся поле,
      нажмите "Подтвердить" — ссылка на созданную карточку появится ниже и будет храниться в истории созданных вами
      карточек сутки. Скопируйте её и укажите в соответствующем поле в настройках альбома и трека.
    </p>
    <div className={"text-center mb-3"}>
      <img className={"max-h-[350px]"} src={"/help/add_artist.jpg"} alt={"Добавить новый альбом"} />
    </div>
    <p>
      Вы можете получить доступ к Студии с помощью ID новой карточки артиста, чтобы оформить ее до выхода первого релиза
      артиста, для этого возьмите из кабинета значение Artist ID и вставьте его в поле поиска, а далее заполняйте
      анкету.
    </p>
  </div>;
};
